import React from "react";
import { Trans } from "react-i18next";

import {
  Callout,
  Button,
  InputGroup,
  Tag,
  Dialog,
  Classes,
  FormGroup,
  Icon,
  HTMLSelect,
  Checkbox,
} from "@blueprintjs/core";

import {
  Cell,
  Column,
  ColumnHeaderCell,
  RowHeaderCell,
  Table2,
} from "@blueprintjs/table";

import {
  authenticatedGetFetch,
  authenticatedPutFetch,
} from "../../../utils/AuthenticatedFetch";
import i18n from "../../../i18n";
import { ParkSelect } from "../../Structure/ParkSelector";

export default class DeviceTable extends React.Component {
  constructor() {
    super();
    this.state = {
      parks: [],
      devices: [],
      editing: -1,
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  updateTable() {
    authenticatedGetFetch("/parks", (response) => {
      const parks = {};
      for (const park of response)
        parks[park.id] =
          park.name !== null ? park.id + " - " + park.name : park.id;
      this.setState({ parks: parks }, () =>
        authenticatedGetFetch("/devices", (response) =>
          this.setState({ devices: response })
        )
      );
    });
  }

  render() {
    return (
      <Callout title={<Trans>devices</Trans>}>
        <Callout intent="primary">
          devices are automatically created if missing when a state is received
        </Callout>

        {/* editing dialog */}
        <Dialog
          style={{ transition: "none" }}
          isOpen={this.state.editing >= 0}
          onClose={() => this.setState({ editing: -1, creating_error: false })}
          title={<Trans>edit device</Trans>}
        >
          {this.state.editing >= 0 && (
            <div className={Classes.DIALOG_BODY}>
              <form
                onSubmit={(e) => {
                  e.preventDefault(); // to avoid reload of the page on submit
                  authenticatedPutFetch(
                    "/device/" +
                      this.state.devices[this.state.editing]["park"]["server"][
                        "id"
                      ] +
                      "/" +
                      this.state.devices[this.state.editing]["id"],
                    {
                      name: this.state.input_name,
                      type: this.state.input_type,
                      display: this.state.input_display,
                      camera: this.state.input_camera,
                      generation: this.state.input_generation,
                      park: this.state.input_park,
                    },
                    () =>
                      this.setState(
                        { editing: -1, creating_error: false },
                        () => this.updateTable()
                      ),
                    () => this.setState({ creating_error: true })
                  );
                }}
              >
                <p>
                  <Trans>server</Trans>
                  <Trans>:</Trans>
                  <Tag large={true}>
                    {
                      this.state.devices[this.state.editing]["park"]["server"][
                        "name"
                      ]
                    }
                  </Tag>
                </p>

                <FormGroup
                  label={<Trans>park</Trans>}
                  labelFor="input_park"
                  inline={true}
                >
                  <ParkSelect
                    id="input_park"
                    srv={
                      this.state.devices[this.state.editing]["park"]["server"][
                        "id"
                      ]
                    }
                    initialValue={
                      this.state.devices[this.state.editing]["park"]
                    }
                    onSelect={(_pkid, park) =>
                      this.setState({ input_park: park.pk })
                    }
                  />
                </FormGroup>

                <p>
                  <Trans>device id</Trans>
                  <Trans>:</Trans>
                  <Tag large={true}>
                    {this.state.devices[this.state.editing]["id"]}
                  </Tag>
                </p>

                <FormGroup
                  label={<Trans>label</Trans>}
                  labelFor="input_name"
                  inline={true}
                >
                  <InputGroup
                    id="input_name"
                    intent={this.state.creating_error ? "danger" : "normal"}
                    onChange={(ti) =>
                      this.setState({ input_name: ti.target.value })
                    }
                    value={this.state.input_name}
                  />
                </FormGroup>

                <FormGroup
                  label={<Trans>device type</Trans>}
                  helperText="used to switch icon on supervison and for statistics"
                  labelFor="input_type"
                  inline={true}
                >
                  <HTMLSelect
                    id="input_type"
                    options={[
                      { value: "BE", label: i18n.t("BE") },
                      { value: "CM", label: i18n.t("CM") },
                      { value: "LP", label: i18n.t("LP") },
                      { value: "CA", label: i18n.t("CA") },
                      { value: "BS", label: i18n.t("BS") },
                    ]}
                    onChange={(ti) =>
                      this.setState({ input_type: ti.target.value })
                    }
                    value={this.state.input_type}
                  />
                  <HTMLSelect
                    options={[
                      { value: "300", label: "Gamme 300" },
                      { value: "400", label: "Gamme 400" },
                    ]}
                    onChange={(ti) =>
                      this.setState({ input_generation: ti.target.value })
                    }
                    value={this.state.input_generation}
                  />
                </FormGroup>

                <FormGroup
                  label={<Trans>display</Trans>}
                  helperText="display on supervision page and envent flow"
                  labelFor="input_display"
                  inline={true}
                >
                  <Checkbox
                    id="input_display"
                    intent={this.state.creating_error ? "danger" : "normal"}
                    type="number"
                    onChange={(ti) =>
                      this.setState({ input_display: ti.target.checked })
                    }
                    checked={this.state.input_display}
                  />
                </FormGroup>

                <FormGroup
                  label={<Trans>camera</Trans>}
                  labelFor="input_camera"
                  inline={true}
                >
                  <InputGroup
                    id="input_camera"
                    intent={this.state.creating_error ? "danger" : "normal"}
                    onChange={(ti) =>
                      this.setState({ input_camera: ti.target.value })
                    }
                    value={this.state.input_camera}
                  />
                </FormGroup>

                <Button
                  text={<Trans>edit</Trans>}
                  intent="primary"
                  icon="edit"
                  type="submit"
                />
              </form>
            </div>
          )}
        </Dialog>

        <Table2
          cellRendererDependencies={[this.state.devices]}
          numRows={this.state.devices.length}
          rowHeaderCellRenderer={(rowIndex) => (
            <RowHeaderCell
              index={rowIndex}
              name={this.state.devices[rowIndex]["id"]}
            />
          )}
        >
          {/* park */}
          <Column
            id="park"
            cellRenderer={(rowIndex) => {
              if (this.state.devices[rowIndex]["park"])
                return (
                  <Cell>
                    {this.state.devices[rowIndex]["park"]["name"] ||
                      this.state.devices[rowIndex]["park"]["id"]}
                  </Cell>
                );
              else return <Cell></Cell>;
            }}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>park</Trans>} />
            )}
          />

          {/* label */}
          <Column
            id="label"
            cellRenderer={(rowIndex) => (
              <Cell>{this.state.devices[rowIndex]["name"]}</Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>label</Trans>} />
            )}
          />

          {/* type */}
          <Column
            id="type"
            cellRenderer={(rowIndex) => (
              <Cell>
                <Trans>{this.state.devices[rowIndex]["type"]}</Trans>
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>device type</Trans>} />
            )}
          />

          {/* IP */}
          <Column
            id="IP"
            cellRenderer={(rowIndex) => (
              <Cell>{this.state.devices[rowIndex]["ip"]}</Cell>
            )}
            columnHeaderCellRenderer={() => <ColumnHeaderCell name="IP" />}
          />

          {/* generation */}
          <Column
            id="generation"
            cellRenderer={(rowIndex) => {
              switch (this.state.devices[rowIndex]["generation"]) {
                case "300":
                  return <Cell>Gamme 300</Cell>;
                case "400":
                  return <Cell>Gamme 400</Cell>;
                default:
                  return (
                    <Cell intent="warning">
                      <Trans>unknown</Trans>
                    </Cell>
                  );
              }
            }}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>generation</Trans>} />
            )}
          />

          {/* camera */}
          <Column
            id="type"
            cellRenderer={(rowIndex) => (
              <Cell>{this.state.devices[rowIndex]["camera"]}</Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>camera</Trans>} />
            )}
          />

          {/* display */}
          <Column
            id="display"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.devices[rowIndex]["display"] ? (
                  <Icon intent="success" icon="tick" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>display</Trans>} />
            )}
          />

          {/* edit */}
          <Column
            id="edit"
            cellRenderer={(rowIndex) => (
              <Cell>
                <Tag
                  icon="edit"
                  minimal={true}
                  interactive={true}
                  onClick={() =>
                    this.setState({
                      editing: rowIndex,
                      input_id: this.state.devices[rowIndex]["id"],
                      input_name: this.state.devices[rowIndex]["name"],
                      input_ip: this.state.devices[rowIndex]["ip"],
                      input_capacity: this.state.devices[rowIndex]["capacity"],
                      input_display: this.state.devices[rowIndex]["display"],
                      input_type: this.state.devices[rowIndex]["type"],
                      input_camera: this.state.devices[rowIndex]["camera"],
                      input_generation:
                        this.state.devices[rowIndex]["generation"],
                      input_park: this.state.devices[rowIndex]["park"]["pk"],
                    })
                  }
                />
              </Cell>
            )}
            columnHeaderCellRenderer={(index) => (
              <ColumnHeaderCell index={index} />
            )}
          />
        </Table2>
      </Callout>
    );
  }
}
